export const DsTabDefaultProps = {
    iconPosition: 'start'
};
